/* ============================================================
   MOCKNIWEAR THEME — JavaScript
   ============================================================ */

document.addEventListener('DOMContentLoaded', () => {

  // --- Cart Drawer -------------------------------------------
  const cartDrawer = document.getElementById('cart-drawer');
  const cartDrawerOverlay = cartDrawer?.querySelector('.cart-drawer__overlay');
  const cartDrawerClose = cartDrawer?.querySelector('.cart-drawer__close');

  function openCartDrawer() {
    cartDrawer?.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    fetchCart();
  }

  function closeCartDrawer() {
    cartDrawer?.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  cartDrawerOverlay?.addEventListener('click', closeCartDrawer);
  cartDrawerClose?.addEventListener('click', closeCartDrawer);

  document.querySelectorAll('[data-cart-open]').forEach(el => {
    el.addEventListener('click', openCartDrawer);
  });

  // --- Fetch & Render Cart -----------------------------------
  async function fetchCart() {
    try {
      const res = await fetch('/cart.js');
      const cart = await res.json();
      renderCartDrawer(cart);
    } catch (e) { console.error('Cart fetch failed', e); }
  }

  function renderCartDrawer(cart) {
    const body = document.getElementById('cart-drawer-body');
    const subtotalEl = document.getElementById('cart-subtotal');

    if (!body) return;

    if (cart.item_count === 0) {
      body.innerHTML = '<p class="cart-drawer__empty">Your bag is empty.</p>';
      if (subtotalEl) subtotalEl.textContent = formatMoney(0);
      updateCartCount(0);
      return;
    }

    const html = cart.items.map(item => `
      <div class="cart-item">
        <img class="cart-item__image" src="${item.image}" alt="${item.title}">
        <div class="cart-item__info">
          <div class="cart-item__title">${item.product_title}</div>
          <div class="cart-item__variant">${item.variant_title || ''}</div>
          <div class="cart-item__price">${formatMoney(item.final_line_price)}</div>
          <button class="cart-item__remove" data-remove-id="${item.key}">Remove</button>
        </div>
      </div>
    `).join('');

    body.innerHTML = html;
    if (subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price);
    updateCartCount(cart.item_count);

    body.querySelectorAll('[data-remove-id]').forEach(btn => {
      btn.addEventListener('click', () => removeCartItem(btn.dataset.removeId));
    });
  }

  async function removeCartItem(key) {
    await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: 0 })
    });
    fetchCart();
  }

  function updateCartCount(count) {
    document.querySelectorAll('.cart-count').forEach(el => {
      el.textContent = count;
      el.style.display = count > 0 ? 'flex' : 'none';
    });
  }

  function formatMoney(cents) {
    return (cents / 100).toLocaleString('en-US', { style: 'currency', currency: 'USD' });
  }

  // --- Add to Cart ------------------------------------------
  document.querySelectorAll('[data-add-to-cart]').forEach(btn => {
    btn.addEventListener('click', async (e) => {
      const variantId = btn.dataset.variantId || btn.closest('[data-variant-id]')?.dataset.variantId;
      if (!variantId) return;
      btn.textContent = 'Adding…';
      btn.disabled = true;
      try {
        await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: variantId, quantity: 1 })
        });
        btn.textContent = 'Added!';
        openCartDrawer();
      } catch (e) {
        btn.textContent = 'Error';
      } finally {
        setTimeout(() => {
          btn.textContent = btn.dataset.label || 'Add to Bag';
          btn.disabled = false;
        }, 2000);
      }
    });
  });

  // --- Mobile Nav -------------------------------------------
  const navToggle = document.querySelector('.nav-toggle');
  const mobileNav = document.querySelector('.mobile-nav');
  const mobileNavClose = document.querySelector('.mobile-nav__close');

  navToggle?.addEventListener('click', () => {
    mobileNav?.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  });

  function closeMobileNav() {
    mobileNav?.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  mobileNavClose?.addEventListener('click', closeMobileNav);

  // --- Product Accordion ------------------------------------
  document.querySelectorAll('.product-accordion__trigger').forEach(trigger => {
    trigger.addEventListener('click', () => {
      const content = trigger.nextElementSibling;
      const isOpen = content.classList.contains('is-open');
      document.querySelectorAll('.product-accordion__content').forEach(c => c.classList.remove('is-open'));
      if (!isOpen) content.classList.add('is-open');
    });
  });

  // --- Gallery Thumbs ---------------------------------------
  document.querySelectorAll('.product-gallery__thumb').forEach(thumb => {
    thumb.addEventListener('click', () => {
      const gallery = thumb.closest('.product-gallery');
      const mainImg = gallery.querySelector('.product-gallery__main img');
      if (mainImg) {
        // Use the pre-rendered full-size URL from data attribute
        const fullSrc = thumb.dataset.full;
        if (fullSrc) {
          mainImg.src = fullSrc;
          mainImg.srcset = '';
        }
        gallery.querySelectorAll('.product-gallery__thumb').forEach(t => t.classList.remove('active'));
        thumb.classList.add('active');
      }
    });
  });

  // --- Size Selector ----------------------------------------
  document.querySelectorAll('.size-btn').forEach(btn => {
    btn.addEventListener('click', () => {
      if (btn.classList.contains('unavailable')) return;
      btn.closest('.size-grid').querySelectorAll('.size-btn').forEach(b => b.classList.remove('selected'));
      btn.classList.add('selected');
    });
  });

  // --- Scroll reveal ----------------------------------------
  if ('IntersectionObserver' in window) {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.style.opacity = '1';
          entry.target.style.transform = 'translateY(0)';
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1 });

    document.querySelectorAll('.product-card, .collection-tile, .testimonial').forEach(el => {
      el.style.opacity = '0';
      el.style.transform = 'translateY(20px)';
      el.style.transition = 'opacity 0.5s ease, transform 0.5s ease';
      observer.observe(el);
    });
  }

  // --- Newsletter -------------------------------------------
  document.querySelectorAll('.newsletter-form').forEach(form => {
    form.addEventListener('submit', (e) => {
      e.preventDefault();
      const btn = form.querySelector('button');
      const input = form.querySelector('input');
      btn.textContent = 'Subscribed!';
      input.value = '';
      setTimeout(() => btn.textContent = 'Subscribe', 3000);
    });
  });

  // Initial cart count
  fetchCart();
});
